module.exports = __webpack_public_path__ + "static/media/ELEVEN.47afd4d3.png";